export const isTemplateItem = item => item?.isTemplate === true;

export const filterItemsByTemplateMode = (items, templatesOnly = false) => {
  if (!Array.isArray(items)) {
    return [];
  }
  if (!templatesOnly) {
    return items;
  }
  return items.filter(isTemplateItem);
};

export const shouldCreateFromTemplateSelection = item => isTemplateItem(item);

export const getTemplateCreatedItemLabel = item => {
  const label = item?.label || '';
  return label ? `${label} [depuis template]` : '';
};
